import cn from 'classnames'
import { useFormikContext } from 'formik'
import { isEmpty } from 'lodash'

import SearchBar from 'components/SearchBar'

import { getChangedValues } from 'utils/formik'

const ListFilters = ({
  searchQuery,
  handleSearch,
  setShowValidationErrors,
}) => {
  const { submitForm, dirty, values, initialValues } =
    useFormikContext()

  const changedValues = getChangedValues(values, initialValues)
  const isOnlySmsReceiptMessageChanged =
    Object.keys(changedValues).length === 1 &&
    !isEmpty(changedValues.sms_receipt_message)

  // when only sms_receipt_message is changed and enable_pos_sms_receipts is disabled
  // save button should be disabled
  const isButtonDisabled =
    isOnlySmsReceiptMessageChanged && !values.enable_pos_sms_receipts
      ? true
      : !dirty

  return (
    <div className="venue-settings-filters">
      <button
        className={cn('btn -sm', {
          '-outline': isButtonDisabled,
          '-disabled': isButtonDisabled,
          '-primary': !isButtonDisabled,
        })}
        onClick={() => setShowValidationErrors(true)}
        onSubmit={submitForm}
        disabled={isButtonDisabled}
      >
        Save
      </button>
      <SearchBar
        handleSearch={handleSearch}
        searchQuery={searchQuery}
      />
    </div>
  )
}

export default ListFilters
